export default "__VITE_ASSET__46fff465__"